import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../lib/theme";

/**
 * Small post-login theme toggle. Shows the icon for the theme you'll
 * switch INTO (sun while in dark mode, moon while in light mode).
 */
export const ThemeToggle = ({ variant = "ghost", showLabel = true, testId = "theme-toggle" }) => {
  const { theme, toggle } = useTheme();
  const isLight = theme === "light";
  const cls =
    variant === "icon"
      ? "p-2 rounded-[2px] text-[color:var(--atech-text-dim)] hover:text-[color:var(--atech-text)] hover:bg-[color:var(--atech-surface-hover)] transition-colors"
      : "flex items-center gap-2 text-xs px-3 py-2 rounded-[2px] border border-[color:var(--atech-border)] text-[color:var(--atech-text-dim)] hover:text-[color:var(--atech-text)] hover:border-[color:var(--atech-border-strong)] transition-colors";
  return (
    <button
      onClick={toggle}
      className={cls}
      title={isLight ? "Switch to dark mode" : "Switch to light mode"}
      aria-label="Toggle theme"
      data-testid={testId}
    >
      {isLight ? <Moon size={14} /> : <Sun size={14} />}
      {showLabel && variant !== "icon" && (
        <span className="tracking-[0.16em] uppercase">{isLight ? "Dark" : "Light"}</span>
      )}
    </button>
  );
};

export default ThemeToggle;
